// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandScreen_block_2OsdA","title":"BrandScreen_title_2AWfO"};